module.exports = new __parcel__URL__("services_4.013a142f.png").toString();